<template>
<div class="pt-2 text-start">
    <span class="badge rounded-pill bg-info me-1"> BP : <b> {{curRecordHd.BP_1}}/{{curRecordHd.BP_2}} </b> mmHg. </span>
    <span class="badge rounded-pill bg-info me-1"> Pulse : {{curRecordHd.Pulse}} bpm. </span>
    <span class="badge rounded-pill bg-info me-1"> Weight : {{curRecordHd.Weight}} kg.</span>
    <span class="badge rounded-pill bg-info me-1"> Height : {{curRecordHd.Height}} cm.</span>
    <span class="badge rounded-pill bg-info me-1"> Body temp. : {{curRecordHd.BodyTemp}} C</span>
    <span class="badge rounded-pill bg-info me-1"> SpO2 : {{curRecordHd.SpO2}} %</span>
    <br><span class="badge rounded-pill bg-secondary me-1"> Specimen : {{curRecordHd.Specimen}}</span>
    <br> เอกสาร : <b> {{curRecordHd.RONo}} </b> ชื่อ : <b>{{curRecordHd.PatName}}</b> นามสกุล : <b>{{curRecordHd.PatLName}}</b>
    <br>
    <div class="input-group input-group-sm my-2">
        <div class="input-group-prepend">
          <label for="Remark" class="" style="width:120px;background-color:inherit;">หมายเหตุ :</label>
        </div>
        <textarea readonly id="Remark" ref="Remark" name="Remark" rows="3" cols="70" class="px-1"
          style="resize: both; font-size:80%; background-color:inherit;" v-model="curRecordHd.Remark"></textarea>
    </div>
    <form @submit.prevent="">
        <table id="myAppvResultTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
            <thead class="text-white" style="background:Navy">
            <tr>
                <th>ชุดตรวจ</th>
                <th>เทส</th>
                <th></th>
                <th>เครื่องหมาย</th>
                <th>ผลแล็บ</th>
                <th>MIN / MAX</th>
                <th title="Repeat Checked">R</th>
                <th>หน่วย</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in datalists" :key="item.RODtl2ID" class="my-edit-tr">
                <!-- id และ ValueType : สำหรับใช้เป็น key ในการบันทึกผลและแยกประเภทข้อมูลแต่ละเทส -->
                <input type="text text-info" hidden class="form-control my-edit-input" name="id" :value="item.RODtl2ID">
                <input type="text text-info" hidden class="form-control my-edit-input" name="ValueType" :value="item.ValueType">

                <td class="text-start " :title="item.TestName"><span style="font-size:80%"><span class="badge bg-secondary">{{item.RoomtypeName}}</span> {{ item.TestCode }} {{item.NewPage}} </span> <span class="text-danger" style="font-size:80%;" v-if="item.PropackName"> {{item.PropackName}} </span></td>
                <td class="text-start " v-if="(item.PrintUL==0)"> &nbsp; {{ item.ItemTestName }}</td>
                <td class="text-start " v-else><b>{{ item.ItemTestName }}</b> </td>
                <td class="text-center">{{ _getHighLowSign(item) }}</td>
                <td class="text-start px-3" style="width:100px;">  {{item.PrefixResult}}    </td>
                <!-- <td class="text-start text-primary" v-if="item.ValueType == 0"><b>{{ Number(item.Result.replace(/[,]/g, '')).toFixed(item.Decimals) }}</b> </td> -->
                <td class="text-start text-primary" v-if="item.ValueType == 0"><b>{{ FormatNumResult(item) }}</b> </td>
                <td class="text-start text-primary" v-if="item.ValueType == 1"><b>{{ item.ResultText }}</b> </td>
                <td class="text-start text-primary" v-if="item.ValueType == 2"><b>{{ item.Result }}</b> </td>
                <td style="width:100px;" > {{item.MinValue}} / {{item.MaximumValue}} </td>
                <td class="text-center" style="width:30px;" title="Repeat Checked"> {{ arrRepeatChk[datalists[index].RepeatChecked] }}
                </td>
                <td class="text-start">{{ item.Unit }} </td>
            </tr>
            </tbody>
        </table>
    </form>
    <!-- <button class="btn btn-success" v-if=" curRecordHd.Status == 2" @click="approveRecord()">ยืนยันผลแล็บ</button> -->
    <br>
    <div class="container">
      <span v-if="_adviceText.length>0">คำแนะนำ :: <br></span>
      <div class="alert alert-warning mb-1" v-for="(item, index) in _adviceText" :key="index">
        <strong>{{index+1}}.</strong> {{item}}
      </div>
    </div>
</div>
</template>

<script>
// import axios from 'axios'
import myfuncs from '../myjs/myfuncs.js'
import funcRO from '../myjs/funcRO.js'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    return {
      globalBranchID, globalUserID, globalUserName
    }
  },
  name: 'LabPrint2Dtl',
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      datalists: null,
      curRecordHd: {
        BranchID: 0,
        ROID: 0,
        RONo: '',
        DocDate: null,
        DocTime: null,
        PatID: 0,
        PatName: '',
        PatLName: '',
        IDNo: '',
        ReqClinicID: 0,
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        Remark: '',
        TotalAmt: 0.0,
        DiscRate: 0.0,
        DiscAmt: 0.0,
        TotalAmt_BfVat: 0.0,
        VatRate: 0.0,
        VatAmt: 0.0,
        NetAmt: 0.0,
        PayType: 0,
        EarnestAmt: 0.0,
        Status: 0
      }
    }
  },
  props: ['dataROHead'],
  mounted () {
    // console.log(this.dataROHead)
    if (this.dataROHead == null) {
    } else {
      this.curRecordHd.ROID = this.dataROHead.ROID
      this.curRecordHd.RONo = this.dataROHead.RONo
      this.curRecordHd.PatName = this.dataROHead.PatName
      this.curRecordHd.PatLName = this.dataROHead.PatLName
      this.curRecordHd.IDNo = this.dataROHead.IDNo
      this.curRecordHd.Sex = this.dataROHead.Sex
      this.curRecordHd.Status = this.dataROHead.Status
      this.curRecordHd.Remark = this.dataROHead.Remark

      this.curRecordHd.Weight = this.dataROHead.Weight
      this.curRecordHd.Height = this.dataROHead.Height
      this.curRecordHd.Pulse = this.dataROHead.Pulse
      this.curRecordHd.BodyTemp = this.dataROHead.BodyTemp
      this.curRecordHd.BP_1 = this.dataROHead.BP_1
      this.curRecordHd.BP_2 = this.dataROHead.BP_2
      this.curRecordHd.SpO2 = this.dataROHead.SpO2
      this.curRecordHd.Specimen = this.dataROHead.Specimen

      this.getLabResultData()
    }
  },
  components: {

  },
  computed: {
    // a computed getter
    _adviceText: function () {
      if (this.datalists == null) return []
      // ----------------------------------- //
      var arrAdviceText = []
      for (let i = 0; i < this.datalists.length; i++) {
        var signHL = this._getHighLowSign(this.datalists[i])
        if (signHL === 'L') {
          if (this.datalists[i].AdviceMin !== '') {
            arrAdviceText.push(this.datalists[i].AdviceMin)
          }
        } else if (signHL === 'H') {
          if (this.datalists[i].AdviceMax !== '') {
            arrAdviceText.push(this.datalists[i].AdviceMax)
          }
        }
      }
      return arrAdviceText
    }
  },
  methods: {
    // =========================
    // ใช้ฟังก์ชั่นจากไฟล์ร่วม .js
    FormatNumResult (row) {
      return myfuncs.FormatNumResult(row)
    },
    _getHighLowSign (row) {
      return funcRO.getHighLowSign(row)
    },
    // =========================
    getLabResultData () {
      // MyApiClient.get('getdata/labrequest_all.php')
      MyApiClient.get('getdata/labresult_where.php?id=' + this.curRecordHd.ROID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
        //   setTimeout(function () { $('#myEntryResultTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    }
  }
}
</script>

<style>

</style>
